export default {
  LANGUAGE: 'LANGUAGE',
}


// WEBPACK FOOTER //
// ./src/config/constant.js